import { Logger } from '@frontend/logger';
import { Package, PackageActionName } from '@frontend/package/types';
import { MqttBroker } from '@frontend/pub-sub';
import { useEffect, useRef } from 'react';

import { useAppSelector } from '../../redux/store';

interface UsePackageListenerProps {
    id: string;
    onStateChange?: (pkg: Package) => void;
}

export const usePackageListener = (props: UsePackageListenerProps) => {
    const navigationState = useAppSelector((store) => store.navigation);
    const IotId = navigationState.iot?.id;
    const propsRef = useRef(props);
    propsRef.current = props;

    useEffect(() => {
        if (!IotId) return;

        const callback = (message: string, data: any) => {
            if (message !== PackageActionName.PACKAGE_INFORM_IOT_STATE_CHANGED) return;
            if (!data.package) {
                Logger.warn('Received package state changed without package data', data);
                return;
            }
            propsRef.current.onStateChange?.(data.package);
        };

        MqttBroker.getInstance().subscribe(props.id + '_USE_PACKAGE_LISTENER', 'iots/' + IotId + '/iot', callback);

        return () => {
            MqttBroker.getInstance().unSubscribe(props.id + '_USE_PACKAGE_LISTENER', 'iots/' + IotId + '/iot');
        };
    }, [props.id, IotId]);
};
